import { getLocale } from "../runtime";

const sv_chooseyourcountrytogetshippingmethods = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Välj ditt land för att få fraktmetoder för din plats.`
};

const chooseyourcountrytogetshippingmethods = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_chooseyourcountrytogetshippingmethods(inputs)
	return "chooseYourCountryToGetShippingMethods";
};

export { chooseyourcountrytogetshippingmethods as "chooseYourCountryToGetShippingMethods" };